"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var LocalizationService_1 = __importDefault(require("../localization/LocalizationService"));
var DexfVpcService_1 = __importDefault(require("../../services/vpc/dexf/DexfVpcService"));
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class is used as a simple interface for VPC services.
 */
var VpcService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    function VpcService(options) {
        this.localizationPrefixApplication = null;
        this.localizationEndpoints = null;
        this.localizationOverrides = null;
        this.locale = null;
        this.applicationName = null;
        this.dexfApplicationId = null;
        this.dexfConfigurationVersion = null;
        this.cache = null;
        this.localizationPrefixApplication = options.localizationPrefixApplication;
        this.localizationEndpoints = options.localizationEndpoints;
        this.localizationOverrides = options.localizationOverrides;
        this.locale = options.locale;
        this.applicationName = options.applicationName;
        this.dexfApplicationId = options.dexfApplicationId || null;
        this.dexfConfigurationVersion = options.dexfConfigurationVersion || null;
        this.cache = options.cache || new utilities_1.GlobalCacheStore();
    }
    /**
     * Saves a planner configuration.
     *
     * @param configuration Configuration to save.
     * @param shoppingItems Product items.
     * @param [configurationImage] Configuration image as a base 64 string (e.g. "data:image/jpeg;base64,abc..").
     * @returns Promise object.
     */
    VpcService.prototype.saveConfiguration = function (configuration, shoppingItems, configurationImage) {
        return __awaiter(this, void 0, void 0, function () {
            var service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getService()];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.saveConfiguration(configuration, shoppingItems, configurationImage)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetches and returns a planner configuration.
     *
     * @param id Configuration ID (VPC Code).
     * @returns Promise object.
     */
    VpcService.prototype.getConfiguration = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getService()];
                    case 1:
                        service = _a.sent();
                        return [4 /*yield*/, service.getConfiguration(id)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns service.
     *
     * @returns Service.
     */
    VpcService.prototype.getService = function () {
        return __awaiter(this, void 0, void 0, function () {
            var localizationService, localizedInformation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localizationService = new LocalizationService_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            localizationEndpoints: this.localizationEndpoints,
                            localizationOverrides: this.localizationOverrides,
                            locale: this.locale,
                            cache: this.cache
                        });
                        return [4 /*yield*/, localizationService.getLocalizedInformation()];
                    case 1:
                        localizedInformation = _a.sent();
                        return [2 /*return*/, new DexfVpcService_1.default({
                                endpoint: localizedInformation.endpoints.dexfVpcService,
                                dexfApplicationId: this.dexfApplicationId || this.applicationName,
                                dexfApiKey: localizedInformation.localization.dexfApiKey,
                                dexfConfigurationVersion: this.dexfConfigurationVersion
                            })];
                }
            });
        });
    };
    return VpcService;
}());
exports.default = VpcService;
//# sourceMappingURL=VpcService.js.map